import { Consts } from '../dependencies';
import { Forms } from '../constants';

export const updateFormIdFactory = id => `${Forms.UPDATE_FORM}_${id}`;

export const updateModalIdFactory = id => `${Consts.modals.UPDATE_TAG}_${id}`;
export const deleteModalIdFactory = id => `${Consts.modals.DELETE_TAG}_${id}`;
